(() => {
  if (!location.pathname.startsWith('/policies/') && !/^\/pages\/(shipping-policy|privacy-policy|terms-of-service|return-and-refund-policy)$/.test(location.pathname)) return;
  const body = document.querySelector('.shopify-policy__body, .page-card .rte');
  if (!body || document.querySelector('.scp-policy-tools')) return;
  const headings = [...body.querySelectorAll('h2')].filter(el => el.textContent.trim());
  const tools = document.createElement('div');
  tools.className = 'scp-policy-tools';
  const print = document.createElement('button');
  print.type = 'button';
      print.textContent = 'Print policy';
  print.addEventListener('click', () => window.print());
  const contact = document.createElement('a');
  contact.href = '/pages/contact';
  contact.textContent = 'Need help? Contact us';
  tools.append(print, contact);
  body.after(tools);
  if (headings.length < 2) return;
  const nav = document.createElement('nav');
  nav.className = 'scp-policy-nav';
  nav.setAttribute('aria-label', 'Sections in this policy');
  const top = document.createElement('div');
  top.className = 'scp-policy-nav__top';
  const title = document.createElement('strong');
  title.textContent = 'On this page';
  const hint = document.createElement('span');
  hint.textContent = 'Jump to a section';
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'scp-policy-nav__toggle';
  toggle.textContent = 'Browse sections';
  toggle.setAttribute('aria-expanded', 'false');
  top.append(title, hint, toggle);
  const links = document.createElement('div');
  links.className = 'scp-policy-nav__links';
  links.id = 'scp-policy-section-links';
  toggle.setAttribute('aria-controls', links.id);
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Hide sections' : 'Browse sections';
  });
  const used = new Set();
  headings.forEach((heading, index) => {
    let slug = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
    while (used.has(slug) || document.getElementById(slug)) slug += '-section';
    used.add(slug);
    heading.id = slug;
    const link = document.createElement('a');
    link.href = `#${slug}`;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', () => {
      if (matchMedia('(max-width: 720px)').matches) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = 'Browse sections';
      }
    });
    links.append(link);
  });
  const progress = document.createElement('div');
  progress.className = 'scp-policy-progress';
  progress.setAttribute('aria-hidden', 'true');
  const bar = document.createElement('span');
  progress.append(bar);
  nav.append(top, links, progress);
  body.before(nav);
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const rect = body.getBoundingClientRect();
    const total = Math.max(1, body.offsetHeight - innerHeight * .5);
    bar.style.width = `${Math.round(Math.min(1, Math.max(0, (innerHeight * .25 - rect.top) / total)) * 100)}%`;
    let active = 0;
    headings.forEach((heading, index) => { if (heading.getBoundingClientRect().top <= 170) active = index; });
    [...links.children].forEach((link, index) => {
      link.classList.toggle('is-active', index === active);
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  update();
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  const back = document.createElement('a');
  back.className = 'scp-policy-back';
  back.href = '#MainContent';
  back.textContent = 'Back to top ↑';
  tools.after(back);
})();
